(function () {
  function initViewport(viewport) {
    if (!viewport || viewport.dataset.mtLogoListBound === 'true') return;
    viewport.dataset.mtLogoListBound = 'true';

    const track = viewport.querySelector('[data-carousel-track]');
    if (!track) return;

    const direction = (viewport.dataset.direction || 'left') === 'right' ? 1 : -1;
    const speedPxPerSec = parseInt(viewport.dataset.speed || '60', 10) || 60;

    let rafId = null;
    let lastTs = undefined;
    let offset = 0;
    let loopDistance = 0;
    let isInitialized = false;

    function updatePadding() {
      track.style.paddingLeft = '24px';
      track.style.paddingRight = '0px';
    }

    function computeLoopDistance() {
      const groups = track.querySelectorAll('.mt-logo-list__group');
      const firstGroup = groups[0];

      if (!firstGroup) {
        loopDistance = Math.floor(track.scrollWidth / 2);
        return loopDistance;
      }

      const style = getComputedStyle(track);
      const gap = parseFloat(style.gap || style.columnGap || '0') || 0;
      const items = firstGroup.querySelectorAll('.mt-logo-list__item');

      let width = 0;
      items.forEach(function (item, idx) {
        width += item.getBoundingClientRect().width;
        if (idx < items.length - 1) width += gap;
      });

      // Fallback when items still have no measured width (images not ready).
      if (width < 1) {
        loopDistance = Math.floor(track.scrollWidth / 2);
      } else {
        loopDistance = width + gap;
      }

      if (!isInitialized && direction > 0 && loopDistance > 0) {
        offset = -loopDistance;
        isInitialized = true;
      }

      return loopDistance;
    }

    function startLoop() {
      if (rafId) return;
      lastTs = undefined;
      rafId = requestAnimationFrame(loop);
    }

    function stopLoop() {
      if (!rafId) return;
      cancelAnimationFrame(rafId);
      rafId = null;
    }

    function loop(ts) {
      if (!lastTs) lastTs = ts;
      const dt = Math.min(0.05, (ts - lastTs) / 1000);
      lastTs = ts;

      if (loopDistance <= 0) computeLoopDistance();
      if (loopDistance <= 0) {
        rafId = requestAnimationFrame(loop);
        return;
      }

      offset += direction * speedPxPerSec * dt;

      if (direction < 0) {
        if (offset <= -loopDistance) offset += loopDistance;
      } else if (offset >= 0) {
        offset -= loopDistance;
      }

      track.style.transform = 'translate3d(' + Math.round(offset) + 'px,0,0)';
      rafId = requestAnimationFrame(loop);
    }

    let isDragging = false;
    let startX = 0;
    let dragStartOffset = 0;
    let didDrag = false;

    function onDragStart(e) {
      isDragging = true;
      didDrag = false;
      startX = e.type === 'mousedown' ? e.clientX : e.touches[0].clientX;
      dragStartOffset = offset;
      stopLoop();
    }

    function onDragMove(e) {
      if (!isDragging) return;

      const currentX = e.type === 'mousemove' ? e.clientX : e.touches[0].clientX;
      const diff = currentX - startX;
      if (Math.abs(diff) > 3) didDrag = true;
      if (didDrag) e.preventDefault();

      offset = dragStartOffset + diff;

      const dragDirection = diff > 0 ? -1 : 1;
      if (dragDirection < 0) {
        track.style.paddingLeft = '24px';
        track.style.paddingRight = '0px';
      } else {
        track.style.paddingLeft = '0px';
        track.style.paddingRight = '24px';
      }

      if (loopDistance > 0) {
        if (direction < 0 && offset <= -loopDistance) offset = 0;
        else if (direction > 0 && offset >= 0) offset = -loopDistance;
      }

      track.style.transform = 'translate3d(' + Math.round(offset) + 'px,0,0)';
    }

    function onDragEnd() {
      if (!isDragging) return;
      isDragging = false;
      startLoop();
    }

    viewport.addEventListener('mousedown', onDragStart);
    viewport.addEventListener('mousemove', onDragMove);
    viewport.addEventListener('mouseup', onDragEnd);
    viewport.addEventListener('mouseleave', onDragEnd);
    viewport.addEventListener('touchstart', onDragStart, { passive: true });
    viewport.addEventListener('touchmove', onDragMove, { passive: false });
    viewport.addEventListener('touchend', onDragEnd);
    viewport.addEventListener('touchcancel', onDragEnd);

    function refreshAndStart() {
      updatePadding();
      computeLoopDistance();
      startLoop();
    }

    // Don't block autoplay on lazy image loads — start immediately and remeasure.
    refreshAndStart();

    const imgs = Array.from(track.querySelectorAll('img'));
    imgs.forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) return;
      img.addEventListener(
        'load',
        function () {
          computeLoopDistance();
        },
        { once: true }
      );
      img.addEventListener(
        'error',
        function () {
          computeLoopDistance();
        },
        { once: true }
      );
    });

    let resizeTimer = null;
    function onResize() {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        computeLoopDistance();
      }, 100);
    }
    window.addEventListener('resize', onResize);

    // Remeasure after layout/fonts settle (common on mobile).
    window.setTimeout(computeLoopDistance, 50);
    window.setTimeout(computeLoopDistance, 300);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        computeLoopDistance();
      }).catch(function () {});
    }
  }

  function initAll() {
    document.querySelectorAll('.mt-logo-list [data-carousel-viewport]').forEach(initViewport);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    event.target.querySelectorAll('.mt-logo-list [data-carousel-viewport]').forEach(function (viewport) {
      delete viewport.dataset.mtLogoListBound;
      initViewport(viewport);
    });
  });
})();
